import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpResponse,
    HttpHeaders,
    HttpErrorResponse,
    HttpParams,
    HttpRequest,
    HttpEvent,
    HttpEventType
} from '@angular/common/http';
import { catchError, map, last } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError, Observable, AsyncSubject } from 'rxjs';
import { DisplayService } from './display.service';
import { environment } from '../../environments/environment';

export const httpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
    withCredentials: true
};

const httpCode: any = {
    OK: 200,
    NOT_MODIFIED: 304,
    CREATED: 201,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500,
    UNAUTHORIZED: 401
};

@Injectable({
    providedIn: 'root'
})

export class HttpDataService {

    private static isSetCSRFCalled = false;
    private isCRSFTokenSet = false;
    public CRSFToken: string;
    public csrfAvailable: AsyncSubject<boolean> = new AsyncSubject();
    private apiPrefix = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private router: Router,
        private display: DisplayService,
    ) {
        if (!this.isCRSFTokenSet && !HttpDataService.isSetCSRFCalled) {
            HttpDataService.isSetCSRFCalled = true;
        }
    }


    public getData(serviceUrl, params = {}): Observable<any> {
        let sParams: HttpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                sParams = sParams.append(key, params[key]);
            }
        });
        httpOptions.params = sParams;
        httpOptions.headers = httpOptions.headers.append('Authorization', 'Bearer ' + localStorage.getItem('awc_code'));
        return this.http
            .get<any>(this.apiPrefix + serviceUrl, httpOptions)
            .pipe(catchError(this.handleError.bind(this)));
    }

    public deleteData(serviceUrl, params = {}): Observable<any> {
        let sParams: HttpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                sParams = sParams.append(key, params[key]);
            }
        });
        httpOptions.params = sParams;
        httpOptions.headers = httpOptions.headers.append('Authorization', 'Bearer ' + localStorage.getItem('awc_code'));
        return this.http
            .delete<any>(this.apiPrefix + serviceUrl, httpOptions)
            .pipe(catchError(this.handleError.bind(this)));
    }


    public setCSRFTokenHeader(): Observable<any> {
        return new Observable(observer => {
            const reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
            this.http
                .get<any>('api/csrfToken', { headers: reqHeader })
                .pipe(catchError(this.handleError.bind(this))).subscribe(res => {
                    httpOptions.headers = httpOptions.headers.append('X-CSRF-Token', res._csrf);
                    this.isCRSFTokenSet = true;
                    this.CRSFToken = res._csrf;
                    this.csrfAvailable.next(true);
                    this.csrfAvailable.complete();
                    observer.next(this.CRSFToken);
                    observer.complete();
                });
        });
    }


    public postData(serviceUrl, body, params = {}): Observable<any> {
        let sParams: HttpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                sParams = sParams.append(key, params[key]);
            }
        });
        httpOptions.params = sParams;
        httpOptions.headers = httpOptions.headers.append('Authorization', 'Bearer ' + localStorage.getItem('awc_code'));
        return this.http
            .post<any>(this.apiPrefix + serviceUrl, body, httpOptions)
            .pipe(catchError(this.handleError.bind(this)));
    }


    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            if (error.status === 400) {
                error['error']['message'].forEach(element => {
                    this.display.showToast('error', element);
                });
            }
            if (error.status === httpCode.FORBIDDEN || error.status === httpCode.UNAUTHORIZED) {
                if (typeof error.error === 'object' && error.error.code === 'E_ADMIN_AUTH') {
                } else {
                    this.router.navigate(['auth/login']);
                }
            }
            this.display.hideLoader();
        }
        return throwError(error.error);
    }


    public postFormData(serviceUrl, body, handleLoader = true): Observable<any> {
        const formData = new FormData();
        const fileData = {};

        for (const i in body) {
            if (!body.hasOwnProperty(i)) {
                continue;
            }
            if (body[i] instanceof FileList || body[i] instanceof File || (body[i].constructor === Array && body[i][0] instanceof File)) {
                fileData[i] = body[i];
            } else if (body[i].constructor === Array || this.isObject(body[i])) {
                formData.append(i, JSON.stringify(body[i]));
            } else {
                formData.append(i, body[i]);
            }

        }

        // Handle file data
        for (const i in fileData) {
            if (!body.hasOwnProperty(i)) {
                continue;
            }
            if (fileData[i] instanceof FileList || body[i].constructor === Array) {
                const files = body[i];
                for (let j = 0, len = files.length; j < len; j++) {
                    formData.append(i, files[j]);
                }
            } else {
                formData.append(i, body[i]);
            }
        }

        const options = Object.assign({ reportProgress: true }, httpOptions);

        const req = new HttpRequest('POST', this.apiPrefix + serviceUrl, formData, options);

        return this.http
            .request<any>(req)
            .pipe(
                catchError(this.handleError.bind(this)),
                map((event: HttpEvent<any>) => {
                    this.getEventMessage(event, handleLoader);
                    if (event instanceof HttpResponse) {
                        event = event.body;
                    }
                    return event;
                }),
                last(),
            );
    }

    private getEventMessage(event: HttpEvent<any>, handleLoader: boolean): void {
        if (event.type === HttpEventType.UploadProgress) {
            const percent = Math.round(100 * event.loaded / event.total);
            if (percent === 0) {
                if (handleLoader) {
                    this.display.hideLoader();
                }
            } else if (percent === 100) {
                if (handleLoader) {
                    this.display.showLoader();
                }
            } else {
                if (handleLoader) {
                    this.display.hideLoader();
                }
            }
        }
    }

    private isObject(val) {
        return val !== null && typeof val === 'object';
    }

}
